import React, { useEffect, useMemo, useState, createContext, useRef } from "react";
import {
  useGetIdentity,
  useGetList,
  useGetOne,
  Resource,
  usePermissions,
  useStore,
  useDataProvider,
} from "react-admin";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import { Button as MuiButton, Tooltip } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import DocumentAnalysisShow from "../DocumentAnalysis";
import AddCoapplicant from "./AddCoapplicant";
import CheckIcon from "@mui/icons-material/Check";
import PersonRemoveAlt1Icon from "@mui/icons-material/PersonRemoveAlt1";
import Archive from "./Archive";
import TransferApp from "./TransferApp";
import SendEmailToApplicant from "./SendEmailToApplicant";
import ArchiveAplicant from "./ArchiveAplicant";
import ApplicantDetailBox from "./ApplicantDetailBox";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../Store/store";
import { setUserRole, setUserTrnId } from "../../Store/Slice/usersSlice";
import {
  setAppFooter,
  setAppHeader,
  setisGuestCard,
  setisOpeningForDashboard,
} from "../../Store/Slice/applicationSettingSlice";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import {
  Box,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import WarningPrelimNotice from "./WarningPrelimNotice";
import CancelApp from "./CancelApp";
import ShareAppReport from "./ShareAppReport";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import { ArrowBack } from "@mui/icons-material";
import { RiDeleteBinLine } from "react-icons/ri";
import "../../App.css";
import { GetdeleteddocumentlistList } from "../DocuploadTableComponent/GetDeletedDocumentList";
import AlertDialogTable from "../DocuploadTableComponent/AlertDialogTable";
import VerticalDotsMenu from "../common/VerticalDotsMenu";
import AuditlogModal from "../DocumentAnalysis/Modals/AuditlogModal";
import MoveButton from "../DocumentAnalysis/components/MoveButton";
import SwitchApplicant from "./SwitchApplicant";
import VerificationInfoMessage from "./VerificationInfoMessage";
import { typesofUsers } from "../../config";
import { checkModuleAccess, isSuperAdmin } from "../../Functions/permissions";
import { FaRegNoteSticky } from "react-icons/fa6";
import { JSONTree } from "react-json-tree";
import {
  registerReviewDoneFraudReporter,
  reportFraudForReviewDoneApplicants,
  ReviewDoneFraudReportingContext,
} from "../DocumentAnalysis/reviewDoneFraudReporting";
import {
  buildRiskApplicantPayload,
  deriveRiskIdDocumentNumber,
} from "../DocumentAnalysis/reportFraudUtils";
import { resetPendingDocumentMoveCount } from "../DocumentAnalysis/documentSubmitUtils";
import { resolveBackNavigationTarget } from "./ApplicantDetailBox";
import RiskFlagAlert from "../common/RiskFlagAlert";
import {
  canViewSerialFraudDashboardIndicator,
  getApplicantDetailSerialFraudIndicatorState,
  getSerialFraudRowId,
} from "../../utils/serialFraudDashboard";

declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    neutral?: PaletteOptions["primary"];
  }
}
const getApplicantRiskApplicantId = (applicant: any): string => {
  const applicantId =
    applicant?.id ??
    applicant?.ApplicantID ??
    applicant?.ApplicantId ??
    applicant?.applicant_id ??
    "";
  return String(applicantId);
};
// Update the CircularProgress color prop options
declare module "@mui/material/CircularProgress" {
  interface CircularProgressPropsColorOverrides {
    neutral: true;
  }
}

function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
) {
  const color = props.value === 100 ? "green" : "orange";
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      {/* Apply the calculated color to CircularProgress */}
      <CircularProgress
        variant="determinate"
        value={props.value}
        size="33px"
        sx={{ color: color }}
        thickness={4}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          border:
            props?.value === 100
              ? "0"
              : props?.value === 0
                ? "2px solid #E0E0E0"
                : "1px solid #E0E0E0",
        }}
      >
        {props.value === 100 ? (
          <CheckIcon style={{ color: "green" }} />
        ) : (
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
            fontSize="10px"
          >{`${Math.round(props.value)}%`}</Typography>
        )}
      </Box>
    </Box>
  );
}

export const Applicant = ({
  trn_id,
  userRole = "Docuverus Super Admin",
  children,
}) => {
  const dispatch = useDispatch();
  const { appType } = useParams();
  useEffect(() => {
    dispatch(setUserTrnId(trn_id));
    dispatch(setUserRole(userRole));
    dispatch(setAppHeader(false));
    dispatch(setAppFooter(appType == "2" ? true : false));
    dispatch(setisOpeningForDashboard(appType == "2" ? false : true));

    return () => { };
  }, []);

  return <>{children}</>;
};

const GuestCard = ({
  trn_id,
  userRole = "Docuverus Super Admin",
  children,
}) => {
  const dispatch = useDispatch();

  const params = useParams();

  const location = useLocation();
  const getlocalStorageItem: any = localStorage.getItem(
    "stateRecord" + params?.applicationId
  );
  let locationState = JSON.parse(getlocalStorageItem);
  const {
    data: applicantDatasub,
    isLoading: loading,
  } = useGetOne("getApplicantDetails", { id: trn_id }, { enabled: !!trn_id });
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(setUserTrnId(trn_id));
    dispatch(setUserRole(userRole));
    dispatch(setAppHeader(true));
    dispatch(setAppFooter(true));
    dispatch(setisGuestCard(true));
    dispatch(setisOpeningForDashboard(false));
    return () => { };
  }, []);
  const logo = applicantDatasub?.office_logo || applicantDatasub?.property_logo ? applicantDatasub?.office_logo || applicantDatasub?.property_logo : applicantDatasub?.subscriber_logo;

  return (
    <>
      <div className="">
        <div className="home_content container-lg">
          <div className="application-wrap">
            <div
              className=""
              style={{
                display: "flex",
                alignItems: "center", // To center content vertically
                justifyContent: "left", // To center content horizontally
                flexDirection: "row",
              }}
            >
              <img
                src={logo}
                alt="Logo"
                style={{
                  maxWidth: "50px",
                  height: "auto",
                  marginRight: "5px",
                  display: logo
                    ? "initial"
                    : "none", // Hide the entire image if the source is falsy
                }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement; // Cast to HTMLImageElement
                  target.style.display = "none"; // Hide the broken image
                }}
              />

              {!loading && (
                <strong>
                  {applicantDatasub?.subscriber_details?.CompanyName}
                </strong>
              )}
            </div>
            <div className="application-head">
              <div>
                <Breadcrumbs>
                  <Typography sx={{ fontWeight: "bold" }}>

                    <button
                      title="Go Back"
                      style={{ color: "#2cc0e4" }}
                      className="btn btn-link"
                      onClick={() => {
                        const backTarget = resolveBackNavigationTarget({
                          hasLiveLocationState: Boolean(location?.state),
                          fallbackOrigin: locationState?.from,
                          currentPathname: location?.pathname,
                        });
                        if (!backTarget) {
                          return;
                        }
                        if (backTarget.kind === 'delta') {
                          navigate(backTarget.value);
                          return;
                        }
                        navigate(backTarget.value);
                      }}
                    >
                      {" "}
                      <ArrowBack />
                    </button>

                    <span>Guestcard Details</span>
                  </Typography>
                </Breadcrumbs>
              </div>
            </div>
            <div className="tab-content app-nav-tabcontent">
              <div className="tab-pane fade show active name1-wrap">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export const MoveDocFileContext = createContext<any>(null);
const ApplicantDetailEdit = (props) => {
  const [tab, setTab] = useState(0);
  const activateApplicantTab = (nextIndex: number) => {
    if (!activeApplicants?.length) return;
    const clampedIndex = Math.max(0, Math.min(nextIndex, activeApplicants.length - 1));
    setTab(clampedIndex);
  };
  const [applicantHasNewDocsMap, setApplicantHasNewDocsMap] = useState<Record<string, boolean>>({});
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [moveFileState, setMoveFileState] = useState({ isOpen: false, docId: null, trnID: null, applicantID: null, source_index: null, source_name: null });
  const [pendingMoveDocIds, setPendingMoveDocIds] = useState<Record<string, boolean>>({});
  const { permissions } = usePermissions();
  const dataProvider = useDataProvider();
  const [switchSubscriberObj] = useStore('switchSubscriberName', { value: '', label: '', companyType: '' });

  const getlocalStorageItem: any = localStorage.getItem(
    "stateRecord" + params?.applicationId
  );

  let locationState = JSON.parse(getlocalStorageItem);
  const searchParams = new URLSearchParams(location.search);
  const encodedData: any = searchParams.get("data");

  if (encodedData) {
    locationState = JSON.parse((encodedData));
  }

  const data = location.state || locationState;

  // No changes need in this compoment as of now
  const trn_id = useSelector((state: RootState) => state.users.userTrnId);
  const { id, appType } = useParams();

  const {
    data: applicantDatasub,
    isLoading: loading,
  } = useGetOne("getApplicantDetails", { id: trn_id }, { enabled: !!trn_id });

  const { data: applicantData, isLoading } = useGetList(
    "get_subscriber_inbox_details",
    {
      filter: { ApplicationNumber: data?.id, subscriberid: id },
    }
  );

  const { data: getUserData } = useGetIdentity();
  const { data: CompanyType } = useGetOne("getfilterforinbox", {
    id: id || getUserData?.subscriberid,
  });
  const [toggleDetails, setToggleDetails] = useState(false);
  const [deleteddocs, setdeleteddocs] = useState(false);

  const handleopendeleteddocs = () => {
    setdeleteddocs(true);
  };
  const handleclosedeleteddocs = () => {
    setdeleteddocs(false);
  };

  const filterDataRemove =
    applicantData &&
    applicantData?.length > 0 &&
    applicantData?.filter(
      (item) =>
      (item?.ApplicantStatus !== "Removed" &&
        item?.ApplicantType !== "Applicant" &&
        (item?.ApplicantStatus == "Invited" ||
          item?.ApplicantStatus == "In Progress"))
    );

  const filterData =
    applicantData &&
    applicantData?.length > 0 &&
    applicantData?.filter(
      (item) =>
      (item?.ApplicantStatus !== "Removed" &&
        item?.ApplicantType !== "Applicant")
    );
  const activeApplicants = useMemo(
    () =>
      applicantData?.filter((item) => {
        return item?.ApplicantStatus !== "Removed";
      }) || [],
    [applicantData]
  );
  const [applicantFraudRiskMap, setApplicantFraudRiskMap] = useState<Record<string, boolean | null>>({});

  const detailsHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToggleDetails(event.target.checked);
  };
  const toTime = (value: any) => {
    if (!value) return null;
    const parsed = new Date(value).getTime();
    if (!Number.isNaN(parsed)) return parsed;
    if (typeof value === "string") {
      const normalized = value.includes(" ") ? value.replace(" ", "T") : value;
      const parsedNormalized = new Date(normalized).getTime();
      if (!Number.isNaN(parsedNormalized)) return parsedNormalized;
    }
    return null;
  };
  const isNewDocTimestamp = (docCreatedOn: any, statusUpdatedOn: any) => {
    const docTime = toTime(docCreatedOn);
    if (docTime === null) return false;
    const statusTime = toTime(statusUpdatedOn);
    if (statusTime === null) return true;
    return docTime > statusTime;
  };
  const hasNewDocsFromResponses = (responses: any, statusUpdatedOn: any) => {
    const proofOfIdsData = responses?.[0]?.data || {};
    const incomeData = responses?.[1]?.data || {};
    const bankData = responses?.[2]?.data || {};
    const otherIncomeData = responses?.[3]?.data || {};
    const otherDocsData = responses?.[4]?.data || {};

    const idHasNew =
      isNewDocTimestamp(proofOfIdsData?.identification_data?.file_created_on, statusUpdatedOn) ||
      isNewDocTimestamp(proofOfIdsData?.identification_data?.backfile_created_on, statusUpdatedOn);

    const incomeFiles: any[] =
      incomeData?.employment_details?.employer?.reduce(
        (all, emp) => [...all, ...(emp?.files || [])],
        []
      ) || [];
    const bankFiles: any[] =
      bankData?.banking_details?.banking?.reduce(
        (all, bank) => [...all, ...(bank?.files || [])],
        []
      ) || [];
    const otherIncomeFiles: any[] =
      otherIncomeData?.other_income_details?.otherincome?.reduce(
        (all, income) => [...all, ...(income?.files || [])],
        []
      ) || [];
    const otherDocsFiles: any[] = otherDocsData?.other_documents || [];

    const anyIncomeNew = incomeFiles.some((file) => isNewDocTimestamp(file?.created_on, statusUpdatedOn));
    const anyBankNew = bankFiles.some((file) => isNewDocTimestamp(file?.created_on, statusUpdatedOn));
    const anyOtherIncomeNew = otherIncomeFiles.some((file) => isNewDocTimestamp(file?.created_on, statusUpdatedOn));
    const anyOtherDocsNew = otherDocsFiles.some((file) => isNewDocTimestamp(file?.created_on, statusUpdatedOn));

    return idHasNew || anyIncomeNew || anyBankNew || anyOtherIncomeNew || anyOtherDocsNew;
  };

  useEffect(() => {
    let cancelled = false;
    const computeApplicantTabTags = async () => {
      if (!activeApplicants?.length) {
        setApplicantHasNewDocsMap({});
        return;
      }

      const entries = await Promise.all(
        activeApplicants.map(async (applicant) => {
          const applicantKey = String(applicant?.id || "");
          const trnId = applicant?.Trnid;
          if (!applicantKey || !trnId) return [applicantKey, false] as const;
          try {
            const responses = await Promise.all([
              dataProvider.getOne("proofOfIdsData", { id: trnId }),
              dataProvider.getOne("income", { id: trnId }),
              dataProvider.getOne("bankDoc", { id: trnId }),
              dataProvider.getOne("otherIncomeDoc", { id: trnId }),
              dataProvider.getOne("otherDoc", { id: trnId }),
            ]);
            return [
              applicantKey,
              hasNewDocsFromResponses(responses, applicant?.ApplicationStatusUpdatedOn),
            ] as const;
          } catch (error) {
            return [applicantKey, false] as const;
          }
        })
      );

      if (cancelled) return;
      const nextMap: Record<string, boolean> = {};
      entries.forEach(([applicantKey, hasNew]) => {
        if (applicantKey) nextMap[applicantKey] = hasNew;
      });
      setApplicantHasNewDocsMap(nextMap);
    };

    computeApplicantTabTags();
    return () => {
      cancelled = true;
    };
  }, [activeApplicants, dataProvider]);
  useEffect(() => {
    let cancelled = false;
    const canShowFraudIndicator = canViewSerialFraudDashboardIndicator(getUserData?.userrole);

    const computeApplicantFraudFlags = async () => {
      if (!canShowFraudIndicator || !activeApplicants?.length) {
        setApplicantFraudRiskMap({});
        return;
      }

      const entries = await Promise.all(
        activeApplicants.map(async (applicant) => {
          const applicantKey = getSerialFraudRowId(applicant);
          const applicantId = getApplicantRiskApplicantId(applicant);
          const trnId = applicant?.Trnid;
          if (!applicantKey || !trnId) return [applicantKey, null] as const;

          try {
            const [
              applicantDetailsResponse,
              proofOfIdsDataResponse,
              ssnIdentificationResponse,
            ] = await Promise.all([
              dataProvider.getOne("getApplicantDetails", { id: trnId }),
              dataProvider.getOne("proofOfIdsData", { id: trnId }),
              dataProvider.getOne("ssnGetidentification", { id: trnId }),
            ]);

            const applicantDetails =
              applicantDetailsResponse?.data?.Application_details || {};
            const proofOfIdsData = proofOfIdsDataResponse?.data || {};
            const identificationData = proofOfIdsData?.identification_data || {};
            const ssnData =
              ssnIdentificationResponse?.data?.ssn_data || proofOfIdsData?.ssn_data || {};
            const applicantPhone =
              applicantDetails?.mobile
                ? `${applicantDetails?.country_code || ""}${applicantDetails?.mobile}`
                : proofOfIdsData?.applicant?.mobile || applicant?.Mobile;
            const riskApplicantPayload = buildRiskApplicantPayload({
              firstName:
                applicantDetails?.first_name ||
                identificationData?.first_name ||
                applicant?.FirstName,
              lastName:
                applicantDetails?.last_name ||
                identificationData?.last_name ||
                applicant?.LastName,
              email:
                applicantDetails?.email ||
                proofOfIdsData?.applicant?.email ||
                applicant?.Email,
              phone: applicantPhone,
              ssn: ssnData?.SSNNumber || ssnData?.SSN,
              normalizedIdDocumentNumber: deriveRiskIdDocumentNumber(identificationData),
              identificationData,
            });

            if (Object.keys(riskApplicantPayload).length === 0) {
              return [applicantKey, null] as const;
            }

            const fraudRiskResponse = await dataProvider.getOne(
              "riskIndicatorIsFraudRisk",
              {
                id: `risk-${applicantKey}`,
                meta: {
                  applicant: riskApplicantPayload,
                  context: {
                    applicationId: applicant?.AppID ? String(applicant.AppID) : undefined,
                    applicantId: applicantId || undefined,
                    subscriberId:
                      proofOfIdsData?.applicant?.SubscriberID || applicant?.SubscriberID
                        ? String(
                          proofOfIdsData?.applicant?.SubscriberID || applicant?.SubscriberID
                        )
                        : undefined,
                  },
                },
              }
            );

            const riskFlag = fraudRiskResponse?.data?.riskFlag;
            return [
              applicantKey,
              riskFlag === true ? true : riskFlag === null ? null : false,
            ] as const;
          } catch (_error) {
            return [applicantKey, null] as const;
          }
        })
      );

      if (cancelled) return;
      const nextMap: Record<string, boolean | null> = {};
      entries.forEach(([applicantKey, isFraudRisk]) => {
        if (applicantKey) nextMap[applicantKey] = isFraudRisk;
      });
      setApplicantFraudRiskMap(nextMap);
    };

    computeApplicantFraudFlags();
    return () => {
      cancelled = true;
    };
  }, [activeApplicants, dataProvider, getUserData?.userrole]);
  const logo = applicantDatasub?.office_logo || applicantDatasub?.property_logo ? applicantDatasub?.office_logo || applicantDatasub?.property_logo : applicantDatasub?.subscriber_logo;

  React.useEffect(() => {
    if (appType == "1") {
      document.title = "Applicant Details";
    } else if (appType == "2") {
      document.title = "Doc Analysis Details";
    } else if (appType == "3") {
      document.title = "Guestcard Details";
    } else {
      document.title = "Applicant Details";
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => { };
  }, []);
  useEffect(() => {
    return () => {
      resetPendingDocumentMoveCount(trn_id);
      setPendingMoveDocIds({});
    };
  }, [trn_id]);

  const {
    data: applicationData,
  } = useGetOne(
    "getapplicationinboxdetails",
    {
      id: data?.id,
    },
    { enabled: !!data?.id }
  );
  const reviewDoneFraudReportersRef = useRef(new Map<string, () => void>());
  const reviewDoneFraudReportingContextValue = {
    registerReviewDoneFraudReporter: (applicant, reporter) =>
      registerReviewDoneFraudReporter({
        applicant,
        reporter,
        reporters: reviewDoneFraudReportersRef.current,
      }),
    reportFraudForApplicants: () =>
      reportFraudForReviewDoneApplicants({
        applicants: activeApplicants,
        reporters: reviewDoneFraudReportersRef.current,
      }),
    reportFraudForReviewDoneApplicants: () =>
      reportFraudForReviewDoneApplicants({
        applicants: activeApplicants,
        reporters: reviewDoneFraudReportersRef.current,
      }),
  };
  if (isLoading) return <>Is loading</>;
  if (applicantData)
    if (appType == "3")
      return (
        <>
          <GuestCard
            trn_id={applicantData[0].Trnid}
            userRole={getUserData?.userrole}
          >
            <DocumentAnalysisShow record={applicantData[0]} />
          </GuestCard>
        </>
      );
    else
      return (
        <>
          <MoveDocFileContext.Provider value={{ moveFileState, setMoveFileState, pendingMoveDocIds, setPendingMoveDocIds }}>
            <ReviewDoneFraudReportingContext.Provider
              value={reviewDoneFraudReportingContextValue}
            >
            <MoveButton />
            <Dialog
              open={deleteddocs}
              onClose={handleclosedeleteddocs}
              fullWidth
              sx={{
                "& .MuiDialog-container.MuiDialog-scrollPaper .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper":
                  { maxWidth: 900 },
              }}
            >
              <DialogTitle
                sx={{ m: 0, p: 1, backgroundColor: "Gainsboro" }}
                id="customized-dialog-title"
              >
                Deleted documents
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleclosedeleteddocs}
                sx={{
                  position: "absolute",
                  right: 6,
                  top: 1,

                  color: (theme) => theme.palette.grey[900],
                }}
              >
                {/* <span style={{ fontSize: "12px" }}>Dismiss</span> */}
                <CloseIcon style={{ fontSize: "12px" }} />
              </IconButton>
              <DialogContent
                onClick={handleopendeleteddocs}
                sx={{ margin: "5px 5px 5px 5px", color: "red" }}
              >
                <Resource
                  name="deletedDocument"
                  list={GetdeleteddocumentlistList}
                />
              </DialogContent>
            </Dialog>
            {/* <Header /> */}
            <div
              className={`home_content application-detail-shell ${appType === "2" ? "doc-analysis-shell" : ""}`}
            >

              {appType == "1" && <ApplicantDetailBox appDetails={data} />}

              {/* style={{marginTop: appType !== "1" ? "69px" : ""}} */}
              <div className="application-wrap">
                {appType !== "1" && (
                  <div
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center", // To center content vertically
                      justifyContent: "left", // To center content horizontally
                      flexDirection: "row",
                    }}
                  >
                    <img
                      src={logo}
                      alt="Logo"
                      style={{
                        maxWidth: "50px",
                        height: "auto",
                        marginRight: "5px",
                        display: logo
                          ? "initial"
                          : "none", // Hide the entire image if the source is falsy
                      }}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement; // Cast to HTMLImageElement
                        target.style.display = "none"; // Hide the broken image
                      }}
                    />

                    {!loading && (
                      <strong>
                        {applicantDatasub?.subscriber_details?.CompanyName}
                      </strong>
                    )}
                  </div>
                )}
                <div role="presentation">
                  <Breadcrumbs aria-label="breadcrumb">

                    <Typography sx={{ fontWeight: "bold" }}>
                      {appType != "1" && (
                        <button
                          title="Go Back"
                          style={{ color: "#2cc0e4" }}
                          className="btn btn-link"
                          onClick={() => {
                            const backTarget = resolveBackNavigationTarget({
                              hasLiveLocationState: Boolean(location?.state),
                              fallbackOrigin: locationState?.from,
                              currentPathname: location?.pathname,
                            });
                            if (!backTarget) {
                              return;
                            }
                            if (backTarget.kind === 'delta') {
                              navigate(backTarget.value);
                              return;
                            }
                            navigate(backTarget.value);
                          }}
                        >
                          {" "}
                          <ArrowBack />
                        </button>
                      )}
                      {/* {appType == "1" && <span>Applicant Details</span>} */}
                      {appType == "2" && <span>Doc Analysis Details</span>}
                      {appType == "3" && <span>Guestcard Details</span>}
                    </Typography>
                  </Breadcrumbs>
                </div>
                {appType === "2" && (
                  <VerificationInfoMessage
                    userRole={getUserData?.userrole}
                    className="mb-2"
                  />
                )}
                <fieldset disabled={getUserData?.userrole == typesofUsers.docuverusAdmin && !checkModuleAccess(permissions, "Dashboard", "Edit Application")}>
                  <div className="application-head">
                    <br />

                    <div className="row ml-auto top-actions-row">
                      {!(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                        <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                          <div className="modal-sm">
                            {appType == "1" && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Add"), getUserData?.userrole) && (
                              <AddCoapplicant record={data} buttonAdd />
                            )}
                            {appType == "2" && isSuperAdmin(checkModuleAccess(permissions, "Doc Upload App", "Add"), getUserData?.userrole) && (
                              <AddCoapplicant record={data} buttonAdd />
                            )}
                            {appType == "3" && isSuperAdmin(checkModuleAccess(permissions, "Guest Card App", "Add"), getUserData?.userrole) && (
                              <AddCoapplicant record={data} buttonAdd />
                            )}
                          </div>
                        </div>
                      )}

                      {
                        filterDataRemove &&
                        filterDataRemove?.length > 0 &&
                        !(filterDataRemove.length === 1 && filterDataRemove[0].ApplicantType === "Applicant") &&
                        !(getUserData?.userrole === typesofUsers.landlordThirdPartyAgent) && (
                          <>
                            {appType === "1" &&
                              isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Remove"), getUserData?.userrole) && (
                                <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                                  <div className="modal-sm">
                                    <div className="tooltip-wrapper">
                                      <MuiButton
                                        className="top-action-btn"
                                        startIcon={<PersonRemoveAlt1Icon />}
                                        variant="text"
                                        disableRipple
                                        sx={{
                                          textTransform: "capitalize",
                                          '&:hover': {
                                            backgroundColor: 'inherit',
                                          }
                                        }}
                                      >
                                        Remove
                                      </MuiButton>
                                      <div className="tooltip">
                                        <ul>
                                          {filterDataRemove?.map((application) =>
                                            application?.ApplicantType === "Applicant" ? (
                                              <SwitchApplicant
                                                record={applicantData}
                                                subscriberId={id}
                                                ApplicantRemove
                                              />
                                            ) : (
                                              <ArchiveAplicant
                                                record={application}
                                                buttonRemove
                                              />
                                            )
                                          )}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                            {appType === "2" &&
                              isSuperAdmin(checkModuleAccess(permissions, "Doc Upload App", "Remove"), getUserData?.userrole) && (
                                <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                                  <div className="modal-sm">
                                    <div className="tooltip-wrapper">
                                      <MuiButton
                                        className="top-action-btn"
                                        startIcon={<PersonRemoveAlt1Icon />}
                                        variant="text"
                                        disableRipple
                                        sx={{
                                          textTransform: "capitalize",
                                          '&:hover': {
                                            backgroundColor: 'inherit',
                                          }
                                        }}
                                      >
                                        Remove
                                      </MuiButton>
                                      <div className="tooltip">
                                        <ul>
                                          {filterDataRemove?.map((application) =>
                                            application?.ApplicantType === "Applicant" ? (
                                              <SwitchApplicant
                                                record={applicantData}
                                                subscriberId={id}
                                                ApplicantRemove
                                              />
                                            ) : (
                                              <ArchiveAplicant
                                                record={application}
                                                buttonRemove
                                              />
                                            )
                                          )}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                            {appType === "3" &&
                              isSuperAdmin(checkModuleAccess(permissions, "Guest Card App", "Remove"), getUserData?.userrole) && (
                                <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                                  <div className="modal-sm">
                                    <div className="tooltip-wrapper">
                                      <MuiButton
                                        className="top-action-btn"
                                        startIcon={<PersonRemoveAlt1Icon />}
                                        variant="text"
                                        disableRipple
                                        sx={{
                                          textTransform: "capitalize",
                                          '&:hover': {
                                            backgroundColor: 'inherit',
                                          }
                                        }}
                                      >
                                        Remove
                                      </MuiButton>
                                      <div className="tooltip">
                                        <ul>
                                          {filterDataRemove?.map((application) =>
                                            application?.ApplicantType === "Applicant" ? (
                                              <SwitchApplicant
                                                record={applicantData}
                                                subscriberId={id}
                                                ApplicantRemove
                                              />
                                            ) : (
                                              <ArchiveAplicant
                                                record={application}
                                                buttonRemove
                                              />
                                            )
                                          )}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </>
                        )
                      }

                      {filterData && filterData?.length >= 1 && !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                        <div className="col-lg-auto col-md-auto col-4 col-sm-3 top-actions-switch" style={{ marginTop: '-5px', paddingRight: "0px" }}>
                          <SwitchApplicant
                            record={applicantData}
                            subscriberId={id}
                            switchApplicantProps
                          />
                        </div>
                      )}

                      {
                        !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                          <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                            <div className="modal-sm">
                              {appType == "1" && CompanyType?.CompanyType == "Real Estate" && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Transfer"), getUserData?.userrole) && (
                                <TransferApp record={data} buttonTransfer />
                              )}
                              {appType === "2" && CompanyType?.CompanyType == "Real Estate" && isSuperAdmin(checkModuleAccess(permissions, "Doc Upload App", "Transfer"), getUserData?.userrole) && (
                                <TransferApp record={data} buttonTransfer />
                              )}
                              {appType === "3" && CompanyType?.CompanyType == "Real Estate" && isSuperAdmin(checkModuleAccess(permissions, "Guest Card App", "Transfer"), getUserData?.userrole) && (
                                <TransferApp record={data} buttonTransfer />
                              )}
                            </div>
                          </div>

                        )}

                      {!(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && <div className="col-lg-auto col-md-auto col-4 col-sm-3">

                        {appType === "1" && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Archive"), getUserData?.userrole) && (
                          <div className="modal-sm">
                            <Archive record={data} buttonArchieve />
                          </div>
                        )}
                        {appType === "2" && isSuperAdmin(checkModuleAccess(permissions, "Doc Upload App", "Archive"), getUserData?.userrole) && (
                          <div className="modal-sm">
                            <Archive record={data} buttonArchieve />
                          </div>
                        )}
                        {appType === "3" && isSuperAdmin(checkModuleAccess(permissions, "Guest Card App", "Archive"), getUserData?.userrole) && (
                          <div className="modal-sm">
                            <Archive record={data} buttonArchieve />
                          </div>)}
                      </div>}
                      {(data?.ApplicationStatus == "Invited" ||
                        data?.ApplicationStatus == "Application In Progress" ||
                        data?.ApplicationStatus == "Submitted" ||
                        data?.ApplicationStatus == "Screening") && !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                          <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                            <div className="modal-sm">
                              <CancelApp record={data} buttonCancelApp navigateUser />
                            </div>
                          </div>
                        )}
                      {data?.SecondaryApp &&
                        data?.ApplicationStatus !== "Cancelled" &&
                        !data.Archived &&
                        appType == "1" && !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                          <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                            <div className="modal-sm">
                              <WarningPrelimNotice
                                resendPreliminaryNotice={data?.EmailStatus ? true : false}
                                vewDetailsMounting={true}
                              />
                            </div>
                          </div>
                        )}
                      {appType == "1" && !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                        <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                          <div className="modal-sm">
                            <AuditlogModal record={applicantData?.[0]} />
                          </div>
                        </div>
                      )}

                      {appType == "1" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Invited" &&
                        !applicationData?.data?.[0]?.Archived &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Application In Progress" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Submitted" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Review Pending" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Cancelled" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Archived" &&
                        (switchSubscriberObj?.companyType === "Real Estate" || applicationData?.data?.[0]?.Subscribertype === "Real Estate") &&
                        isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Send App/Report"), getUserData?.userrole) &&
                        getUserData?.userrole !== typesofUsers.landlordThirdPartyAgent &&
                        (
                          <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                            <div className="modal-sm">
                              <ShareAppReport record={data} buttonShareAppReport />
                            </div>
                          </div>
                        )}

                      {appType == "1" && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "View Adverse Letter"), getUserData?.userrole) &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Invited" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Application In Progress" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Submitted" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Review Pending" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Cancelled" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Completed-Approved" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Archived" &&
                        applicationData?.data?.[0]?.ApplicationStatus !== "Screening" && (getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                          <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                            <div className="modal-sm">
                              <button
                                type="button"
                                className=""
                                onClick={() => { navigate('/landloard/landLoardInbox/adverseletter', { state: { SubscriberID: id, ...applicationData?.data[0] } }) }}
                              >
                                <FaRegNoteSticky style={{ fontSize: "14px" }} />
                                <span>&nbsp; View Adverse Letter</span>
                              </button>
                            </div>
                          </div>
                        )}
                      {appType == "1" && !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                        <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                          <div className="modal-sm">
                            <SendEmailToApplicant
                              record={applicantData}
                              buttonSendMail
                            />
                          </div>
                        </div>
                      )}

                      {appType == "2" && !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                        <div className="col-lg-auto col-md-auto col-4 col-sm-3">
                          <div className="modal-sm">
                            <MuiButton
                              className="top-action-btn"
                              onClick={handleopendeleteddocs}
                              startIcon={<RiDeleteBinLine style={{ fontSize: "14px" }} />}
                              variant="text"
                              disableRipple
                              sx={{
                                textTransform: "capitalize",
                                '&:hover': {
                                  backgroundColor: 'inherit',
                                }
                              }}
                            >
                              Deleted docs
                            </MuiButton>
                          </div>
                        </div>
                      )}

                      {appType == "1" && (
                        <VerticalDotsMenu
                          data={data}
                          applicantList={applicantData}
                        />
                      )}
                    </div>

                  </div>
                </fieldset>
                <div className="application-tabs">
                  <div className="nav-flexes">
                    <nav>
                      <div
                        className="nav nav-tabs app-nav-tabs"
                        id="nav-tab"
                        role="tablist"
                      >
                        {activeApplicants
                          ?.map((item, index) => (
                            <button
                              key={getSerialFraudRowId(item) || `${item.AppID}-${index}`}
                              className={`nav-link ${tab === index ? "active" : ""
                                }`}
                              id={`nav-name-tab0${index}`}
                              data-bs-toggle="tab"
                              data-bs-target={"#nav-name" + index}
                              type="button"
                              role="tab"
                              aria-controls={"nav-name" + index}
                              aria-selected="true"
                              onClick={() => {
                                setTab(index);
                              }}
                            >
                              <div className="name1">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    minWidth: 0,
                                  }}
                                >
                                  <h6
                                    style={{
                                      maxWidth: "150px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      fontSize: "15px",
                                      marginBottom: 0,
                                    }}
                                    title={`${item.FirstName} ${item.LastName}`}
                                  >
                                    {`${item.FirstName} ${item.LastName}`}
                                  </h6>
                                </div>
                                {appType == "1" && (
                                  <CircularProgressWithLabel
                                    value={
                                      item?.ApplicantStatus == "Invited"
                                        ? 0
                                        : Number(item?.ApplicationCompleted)
                                    }
                                  />
                                )}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "8px",
                                }}
                              >
                                <small style={{ textAlign: "left", display: "block", textDecoration: "none" }}>
                                  {item?.ApplicantType}
                                </small>
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    flexShrink: 0,
                                  }}
                                >
                                  {(() => {
                                    const fraudRisk = getApplicantDetailSerialFraudIndicatorState(
                                      item,
                                      applicantFraudRiskMap
                                    );
                                    return fraudRisk === true || fraudRisk === null ? (
                                      <RiskFlagAlert
                                        isFraudRiskMatch={fraudRisk}
                                        displayVariant="icon"
                                      />
                                    ) : null;
                                  })()}
                                  {applicantHasNewDocsMap[String(item?.id)] && (
                                    <span
                                      style={{
                                        background: "#01DB3E",
                                        color: "#fff",
                                        fontSize: "10px",
                                        fontWeight: 700,
                                        lineHeight: 1,
                                        borderRadius: "2px",
                                        padding: "2px 5px",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      New
                                    </span>
                                  )}
                                </span>
                              </div>
                            </button>
                          ))}
                      </div>
                    </nav>

                    {appType == "1" && (
                      <div className="toggleWrapper-wrap">
                        <div className="toggleWrapper">
                          <input
                            type="checkbox"
                            className="dn "
                            style={{ display: "none" }}
                            id="dn"
                            onChange={detailsHandler}
                            checked={toggleDetails}
                          />
                          <label htmlFor="dn" className="toggle">
                            <span className="toggle__handler" />
                          </label>
                        </div>
                      </div>
                    )}
                  </div>

                  <div
                    className="tab-content app-nav-tabcontent"
                    id="nav-tabContent"
                  >
                    {
                      activeApplicants?.map((item, index) => (
                        <div
                          key={getSerialFraudRowId(item) || `${item.AppID}-${index}`}
                          className={`tab-pane fade show ${tab === index ? "active" : ""
                            } name1-wrap`}
                          id={`nav-name${index}`}
                          role="tabpanel"
                          aria-labelledby={`nav-name-tab${index}`}
                          tabIndex={index}
                        >
                          {/* Open guest card here */}
                          {/* {tab === index && ( */}
                          <fieldset disabled={getUserData?.userrole == typesofUsers.docuverusAdmin && !checkModuleAccess(permissions, "Dashboard", "Edit Application")}>
                            {appType == "1" ? (
                              <fieldset disabled={!(Number(item?.ApplicationCompleted) > 79)}>
                                <fieldset disabled={getUserData?.userrole == typesofUsers.landlordThirdPartyAgent || !isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Edit"), getUserData?.userrole)}>
                                  <Applicant
                                    trn_id={item.Trnid}
                                    userRole={getUserData?.userrole}
                                  >
                                    <DocumentAnalysisShow
                                      toggleDetails={toggleDetails}
                                      record={item}
                                      index={index}
                                      totalApplicationCount={activeApplicants?.length || 1}
                                      isActiveTab={tab === index}
                                      onNavigatePrevTab={index > 0 ? () => activateApplicantTab(index - 1) : null}
                                      onNavigateNextTab={
                                        index + 1 < (activeApplicants?.length || 0)
                                          ? () => activateApplicantTab(index + 1)
                                          : null
                                      }
                                    />
                                  </Applicant>
                                </fieldset>
                              </fieldset>
                            ) : appType == "2" ? (
                              <fieldset disabled={getUserData?.userrole == typesofUsers.landlordThirdPartyAgent || !isSuperAdmin(checkModuleAccess(permissions, "Doc Upload App", "Edit"), getUserData?.userrole)}>
                                <Applicant
                                  trn_id={item.Trnid}
                                  userRole={getUserData?.userrole}
                                >
                                  <DocumentAnalysisShow
                                    toggleDetails={toggleDetails}
                                    record={item}
                                    index={index}
                                    totalApplicationCount={activeApplicants?.length || 1}
                                    isActiveTab={tab === index}
                                    onNavigatePrevTab={index > 0 ? () => activateApplicantTab(index - 1) : null}
                                    onNavigateNextTab={
                                      index + 1 < (activeApplicants?.length || 0)
                                        ? () => activateApplicantTab(index + 1)
                                        : null
                                    }
                                  />
                                </Applicant>
                              </fieldset>
                            ) : appType == "3" ? (
                              <fieldset disabled={getUserData?.userrole == typesofUsers.landlordThirdPartyAgent || !isSuperAdmin(checkModuleAccess(permissions, "Guest Card App", "Edit"), getUserData?.userrole)}>
                                <Applicant
                                  trn_id={item.Trnid}
                                  userRole={getUserData?.userrole}
                                >
                                  <DocumentAnalysisShow
                                    toggleDetails={toggleDetails}
                                    record={item}
                                    index={index}
                                    totalApplicationCount={activeApplicants?.length || 1}
                                    isActiveTab={tab === index}
                                    onNavigatePrevTab={index > 0 ? () => activateApplicantTab(index - 1) : null}
                                    onNavigateNextTab={
                                      index + 1 < (activeApplicants?.length || 0)
                                        ? () => activateApplicantTab(index + 1)
                                        : null
                                    }
                                  />
                                </Applicant>
                              </fieldset>
                            ) : null
                            }
                          </fieldset>

                          {/* )} */}
                          {/* End guest card here */}

                          {appType == "1" && (
                            <AlertDialogTable trn_id={item.Trnid} />
                          )}
                        </div>
                      ))}
                    {/* ---------------------- */}
                  </div>
                </div>
              </div>
            </div>
            </ReviewDoneFraudReportingContext.Provider>
          </MoveDocFileContext.Provider>
        </>
      );

  return <>No data</>;
};

export default ApplicantDetailEdit;
